// Copyright (c) 2026 Query Health Inc. All rights reserved.
// Author: Shubham Dixit <shubham@quantinohealth.com>
// Licensed under a Commercial License. See LICENSE for terms.

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './i18n/index'
import './index.css'

const root = document.getElementById('root')
if (!root) throw new Error('root element not found')

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
